import axios from "axios";
import React, { useState,useEffect } from "react";
import { useHistory } from "react-router-dom";
import swal from 'sweetalert';
import AdminAutoComplete from "../../admin/AdminAutoComplete";
import UseFullPageLoader from "../../FullPageLoader/UseFullPageLoader";
//import AutoComplete from '../AutoComplete';



const Register = () => {
  document.title = "DirtMap - Register";

  const history = useHistory();
  const [registerInput, setRegister] = useState({
    email: '',
    password: '',
    first_name: '',
    last_name: '',
    company_name: '',
    street_address: '',
    street_address_2: '',
    latitude: '',
    longitude: '',
    country: '',
    state: '',
    city: '',
    user_type: '',
    phone_number: '',
    office_phone: '',
    user_name: '',
    alert_message_type: '',
    item_type : '',
    address: '',
    image :'',
    no_of_truck : '',
    error_list: [],
  });
  const [image, setImage] = useState([]);
  const [userType, setUserType] = useState({
    user_type : 'normal'
  });


  const [isDisplayed, setIsDisplayed] = useState(false);
  const [isHide, setIsShow] = useState(false);
  const [truckTypes, setTruckTypes] = useState([]);
  

  const [loader, showLoader, hideLoader] = UseFullPageLoader();
  const [error_listImage, seterror_listImage] = useState([])
  const [truckRows, setTruckRows] = useState([
    { type_of_truck: "", no_of_truck: ""}
  ])
  const [equipmentRows, setEquipmentRows] = useState([
    { equipment: "", quantity: "" }
  ]);

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [selectedCountryId, setSelectedCountryId] = useState("");
  const [selectedStateId, setSelectedStateId] = useState("");
  const [selectedCityId, setSelectedCityId] = useState("");
  
  // bydefault US selected
  useEffect(() => {
    if (countries.length > 0) {
      const us = countries.find(c => c.name === "United States");

      if (us) {
        setSelectedCountryId(us.id);
        setRegister(prev => ({ ...prev, country: us.id }));
      }
    }
  }, [countries]);


  // Handle Input Change
  // truck add and removed
  const handleTruckChange = (index,e) => {
    const {name, value} = e.target;
    const updated = [...truckRows];
    updated[index][name] = value;
    setTruckRows(updated);
  }

  const addTruckRow = () => {
     setTruckRows([...truckRows, { type_of_truck: "", no_of_truck: ""}]);
  };

  const removeTruckRow = (index) => {
    const updated = [...truckRows];
    updated.splice(index,1);
    setTruckRows(updated);
  } 

  // Handle Input Change
  // equipment add and removed
  const handleEquipmentChange = (index, e) => {
    const { name, value } = e.target;
    const updated = [...equipmentRows];
    updated[index][name] = value;
    setEquipmentRows(updated);
  };

  const addEquipmentRow = () => {
    setEquipmentRows([...equipmentRows, { equipment: "", quantity: "" }]);
  };

  const removeEquipmentRow = (index) => {
    const updated = [...equipmentRows];
    updated.splice(index, 1);
    setEquipmentRows(updated);
  };



useEffect(() => {
  setInterval(() => {
      setIsDisplayed(true);
  }, 1200);
}, []);

useEffect(() => {
  axios.get("/api/truck-types")
    .then(res => {
      if (res.data.success) {
        setTruckTypes(res.data.result);
      }
    }) 
    .catch(err => console.log(err));
}, []);

// Load countries on page load
useEffect(() => {
  axios.get("/api/countryStateCity/list")
    .then(res => {
      if (res.data.success) {
        setCountries(res.data?.result?.items || []);
      }
    })
    .catch(err => console.log(err));
}, []);

// When country changes → load states
useEffect(() => {
  if (!selectedCountryId) {
    setStates([]);
    setCities([]);
    setSelectedStateId("");
    setSelectedCityId("");
    return;
  }

  axios.get(`/api/countryStateCity/list?country_id=${selectedCountryId}`)
    .then(res => {
      setStates(res.data?.result?.items || []);
      setCities([]);
      setSelectedStateId("");
      setSelectedCityId("");
    })
    .catch(err => console.log(err));
}, [selectedCountryId]);

// When country changes → load states
useEffect(() => {
  if (!selectedStateId) {
    setCities([]);
    setSelectedCityId("");
    return;
  }

  axios.get(`/api/countryStateCity/list?state_id=${selectedStateId}`)
    .then(res => {
      setCities(res.data?.result?.items || []);
      setSelectedCityId("");
    })
    .catch(err => console.log(err));
}, [selectedStateId]);


const handleImage = (e) => {
  e.persist();
  setImage({ image: e.target.files });
}

const handleInput = (e) => {
  e.persist();
  setRegister({ ...registerInput, [e.target.name]: e.target.value });

}

const handleUserType = (e) => {
  e.persist();
  setUserType({ ...userType, [e.target.name]: e.target.value });
  if(userType.user_type === 'normal') {
    setIsShow(true);
  } else {
    setIsShow(false);
  }
}

  // const registerSubmit = (e) => {

  //   e.preventDefault();

  //   const data = {
  //     email: registerInput.email,
  //     password: registerInput.password,
  //     first_name: registerInput.first_name,
  //     last_name: registerInput.last_name,
  //     company_name: registerInput.company_name,
  //    // street_address: registerInput.street_address,
  //    // street_address_2: registerInput.street_address_2,
  //    // latitude: registerInput.latitude,
  //    // longitude: registerInput.longitude,
  //    // city: registerInput.city,
  //    // state: registerInput.state,
  //     user_type: registerInput.user_type,
  //     phone_number: registerInput.phone_number,
  //     office_phone: registerInput.office_phone,
  //     user_name: registerInput.user_name,
  //     alert_message_type: registerInput.alert_message_type,
  //   }

  //   showLoader();
  //   axios.get('/sanctum/csrf-cookie').then(res => {
  //     axios.post(`/api/user/register`, data).then(res => {
  //       console.log(res.data)
  //       if (res.data.result) {
  //         hideLoader();
  //         localStorage.setItem('auth_token', res.data.result);
  //         localStorage.setItem('auth_name', res.data.user_name);
  //         swal("success", res.data.message, "success");
  //         history.push('/');
  //       }
  //       else {
  //         hideLoader();
  //         setRegister({ ...registerInput, error_list: res.data.errors });
  //       }

  //     });

  //   });


  // }

  const registerSubmit = (e) => {
    e.preventDefault();
        const formData = new FormData();
        if(image.image && image.image.length > 0){
            //formData.append('image', image.image);
            for (let i = 0; i < image.image.length; i++) {
              console.log(i);
              formData.append(`post_image[${i}]`, image.image[i])
            }
        }
        formData.append('email', registerInput.email);
        formData.append('item_type', registerInput.item_type);
        formData.append('password', registerInput.password);
        formData.append('first_name', registerInput.first_name);
        formData.append('last_name', registerInput.last_name);
        formData.append('address', registerInput.address);  
        formData.append('latitude', registerInput.latitude);
        formData.append('longitude', registerInput.longitude);
        formData.append('company_name', registerInput.company_name);
        formData.append('user_type', userType.user_type);
        formData.append('phone_number', registerInput.phone_number);
        formData.append('office_phone', registerInput.office_phone);
        formData.append('user_name', registerInput.user_name);
        formData.append('alert_message_type', registerInput.alert_message_type);
        formData.append('country', selectedCountryId);
        formData.append('state', selectedStateId);
        formData.append('city', selectedCityId);

        // formData.append('type_of_truck', registerInput.type_of_truck);
        // formData.append('no_of_truck', registerInput.no_of_truck);
        truckRows.forEach((row, i) => {
          formData.append(`trucks[${i}][type_of_truck]`, row.type_of_truck);
          formData.append(`trucks[${i}][no_of_truck]`, row.no_of_truck);
        });

        equipmentRows.forEach((row, i) => {
          formData.append(`equipments[${i}][equipment]`, row.equipment);
          formData.append(`equipments[${i}][quantity]`, row.quantity);
        });

        console.log(formData)
        showLoader();
        axios.get('/sanctum/csrf-cookie').then(res => {
          axios.post(`/api/user/register`, formData).then(res => {
            if (res.data.result) {
              console.log("user_id" +res.data.user_id);
              console.log("user_type" +JSON.stringify(res.data));
              hideLoader();
              localStorage.setItem('auth_token', res.data.result);
              localStorage.setItem('auth_name', res.data.user_name);
              localStorage.setItem('user_id', res.data.user_id); 
              localStorage.setItem('type', res.data.user_type);  
              swal("success", res.data.message, "success");
              history.push('/');
            }
            else {
              hideLoader();
              setRegister({ ...registerInput, error_list: res.data.errors });
            }
            });
        });

}


  const setCoodinationValueAddress = (results, ll) => {
    const fullAddress = results[0].formatted_address;

    let street1 = "", street2 = "", city = "", state = "", zip = "", country = "";

    // Loop through address_components correctly
    for (let i = 0; i < results[0].address_components.length; i++) {
      const component = results[0].address_components[i];
      const types = component.types;

      if (types.includes("street_number") || types.includes("sublocality_level_1"))
        street1 = component.long_name || "";

      if (types.includes("route") || types.includes("sublocality_level_2"))
        street2 = component.long_name || "";

      if (types.includes("locality"))
        city = component.long_name || "";

      if (types.includes("administrative_area_level_1") || types.includes("administrative_area_level_2"))
        state = component.long_name || "";

      if (types.includes("postal_code"))
        zip = component.long_name || "";

      if (types.includes("country"))
        country = component.long_name || "";
    }

    // ✅ Update React state properly
    setRegister((prev) => ({
      ...prev,
      street_address: street1,
      street_address_2: street2,
      city: city,
      state: state,
      address: fullAddress,
      latitude: ll.lat,
      longitude: ll.lng,
    }));

    // ✅ Optional if you still need them in hidden inputs
    document.getElementById("__postLatitude").value = ll.lat;
    document.getElementById("__postLongitude").value = ll.lng;
    document.getElementById("__postSearchLocationAdress").value = street1;

    console.log("Full Address:", fullAddress);
    console.log("Lat:", ll.lat, "Lng:", ll.lng);
};

  return (
    <section className="contentContainer02 registerBlock">
      <div className="container">
        <div className="shadowBox contactForm pb-5">
          <div className="row">
            <div className="col-lg-5 col-md-6">
              <div className="largeSideThumb text-center">
                <img src={"./frontend/images/register-left-thumb.jpg"} alt="" className="imgResponsive" />
              </div>
            </div>
            <div className="col-lg-7 col-md-6">
              <form onSubmit={registerSubmit}>
                <h2 className="mt-3 mb-3">Enter Your Details</h2>
                <div className="customFormRow">
                  <div className="inputField">
                    <input type="hidden" id="__postSearchLocationAdress" name="street_address" onChange={handleInput} value={registerInput.street_address} />
                    <input type="hidden" id="__postAddress" name="address" value={registerInput.address} />
                    <input type="hidden" id="__postLatitude" name="latitude" onChange={handleInput} value={registerInput.latitude} />
                    <input type="hidden" id="__postLongitude" name="longitude" onChange={handleInput} value={registerInput.longitude} />
                    <input type="email" name="email" onChange={handleInput} value={registerInput.email} placeholder="Enter Your Email" />
                    <span className="text-danger">{registerInput.error_list.email}</span>
                  </div>
                  <div className="inputField">
                    <input type="password" name="password" onChange={handleInput} value={registerInput.password} placeholder="Enter Your Password" />
                    <span className="text-danger">{registerInput.error_list.password}</span>
                  </div>
                </div>
                <div className="customFormRow">
                  <div className="inputField">
                    <input type="text" name="first_name" onChange={handleInput} value={registerInput.first_name} placeholder="Enter Your First Name" />
                    <span className="text-danger">{registerInput.error_list.first_name}</span>

                  </div>
                  <div className="inputField">
                    <input type="text" name="last_name" onChange={handleInput} value={registerInput.last_name} placeholder="Enter Your Last Name" />
                    <span className="text-danger">{registerInput.error_list.last_name}</span>
                  </div>
                </div>
                <div className="customFormRow">
                  <div className="inputField">
                    <input type="text" name="company_name" onChange={handleInput} value={registerInput.company} placeholder="Enter Your Company" />
                    <span className="text-danger">{registerInput.error_list.company_name}</span>
                  </div>
                  <div className="inputField">
                    <input type="text" name="office_phone" onChange={handleInput} value={registerInput.office_phone} placeholder="Enter Your Office Phone" />
                    <span className="text-danger">{registerInput.error_list.office_phone}</span>
                  </div>
                  {/* <div className="inputField">

                    {isDisplayed &&
                          <AdminAutoComplete
                              apiKey={'AIzaSyCv7m-2LTrrKnu1P38xKNBvvFJXoQGAnGg'}
                              setCoodinationValueAddress={setCoodinationValueAddress}
                          />
                      }

                    <span className="text-danger">{registerInput.error_list.street_address}</span>
                  
                  </div> */}
                </div>
                  {/* 
                  <div className="inputField">

                    <input type="text" id="__postSearchLocationAdress2" name="street_address_2" onChange={handleInput} value={registerInput.street_address_2} placeholder="Enter Your Street Address 2" />

                    <span className="text-danger">{registerInput.error_list.street_address_2}</span>
                  
                  </div>*/}
                <div className="customFormRow">
                  <div className="inputField">
                    <select
                      className="form-control"
                      value={selectedCountryId}
                      onChange={(e) => {
                        const id = e.target.value;
                        setSelectedCountryId(id);

                        // store also in form state if you need
                        setRegister(prev => ({ ...prev, country: id }));
                      }}
                    >
                      <option value="">Select Country</option>
                      {countries.map(c => (
                        <option key={c.id} value={c.id}>
                          {c.name}
                        </option>
                      ))}
                    </select>
                    <span className="text-danger">{registerInput.error_list.country}</span>
                  </div>

                  <div className="inputField">
                    <select
                      className="form-control"
                      value={selectedStateId}
                      disabled={!selectedCountryId}
                      onChange={(e) => {
                        const id = e.target.value;
                        setSelectedStateId(id);
                        setRegister(prev => ({ ...prev, state: id }));
                      }}
                    >
                      <option value="">Select State</option>
                      {states.map(s => (
                        <option key={s.id} value={s.id}>
                          {s.name}
                        </option>
                      ))}
                    </select>
                    <span className="text-danger">{registerInput.error_list.state}</span>
                  </div>
                </div>

                <div className="customFormRow">
                  <div className="inputField">
                    <select
                      className="form-control"
                      value={selectedCityId}
                      disabled={!selectedStateId}
                      onChange={(e) => {
                        const id = e.target.value;
                        setSelectedCityId(id);
                        setRegister(prev => ({ ...prev, city: id }));
                      }}
                    >
                      <option value="">Select City</option>
                      {cities.map(ci => (
                        <option key={ci.id} value={ci.id}>
                          {ci.name}
                        </option>
                      ))}
                    </select>
                    <span className="text-danger">{registerInput.error_list.city}</span>
                  </div>
                </div>

                <div className="customFormRow">
                  <div className="inputField">
                    {/* <input type="text" id="__postSearchLocationState" name="state" onChange={handleInput} value={registerInput.state} placeholder="Enter Your State" />
                    <span className="text-danger">{registerInput.error_list.state}</span> */}
                    <input type="text" name="user_name" onChange={handleInput} value={registerInput.user_name} placeholder="Enter Your username" />
                    <span className="text-danger">{registerInput.error_list.user_name}</span>
                  </div>
                  <div className="inputField">
                  <input type="text" name="phone_number" onChange={handleInput} value={registerInput.phone_number} placeholder="Enter Your Phone Number" />
                    <span className="text-danger">{registerInput.error_list.phone_number}</span>
                  </div>
                </div>
                <div className="customFormRow">
                  <div className="inputField">
                    <select name="user_type" onChange={handleUserType} value={userType.user_type} className="form-control">
                      <option value="normal">User</option>
                      <option value="contractor">Trucker</option>
                    </select>
                    <span className="text-danger">{registerInput.error_list.user_type}</span>
                  </div>
                  <div className="inputField">
                    <label className="customCheckBox">
                      <input type="checkbox" name="alert_message_type" onChange={handleInput} value="0" />
                      <span className="checkmark"></span>Email Alert </label>
                    <label className="customCheckBox">
                      <input type="checkbox" name="alert_message_type" onChange={handleInput} value="1" />
                      <span className="checkmark"></span>Text Messages </label>
                    <span className="text-danger">{registerInput.error_list.alert_message_type}</span>

                  </div>
                </div>
                {isHide && (
                <div className={`sitepost-section`}>
                  {truckRows.map((row, index) => (
                    <div className="customFormRow" key={index}>
                      <div className="inputField">
                        {/* <select name="item_type" onChange={handleInput} value={registerInput.item_type} className="form-control">
                            <option value="">Type</option>
                            <option value="import">Import</option>
                            <option value="export">Export</option>
                            <option value="dump_site">Dump Site</option>
                            <option value="truks">Trucks</option>

                        </select> */}
                        <select name="type_of_truck" 
                          onChange={(e) => handleTruckChange(index, e)}
                          value={row.type_of_truck} 
                          className="form-control">
                            <option value="">Select Truck Type</option>
                            {truckTypes.map((item) => (
                              <option key={item.id} value={item.name}>
                                {item.name}
                              </option>
                            ))}
                        </select>
                        
                        <span className="validate-error-message">{registerInput.error_list.item_type}</span>
                      </div>
                      <div className="">
                        <input
                          type="number"
                          name="no_of_truck"
                          value={row.no_of_truck}
                          onChange={(e) => handleTruckChange(index, e)}
                          placeholder="Enter Your No Of Truck"
                        />
                        <span className="text-danger">{registerInput.error_list.no_of_truck}</span>
                      </div>
                      {/* REMOVE button only if more than one row */}
                      {truckRows.length > 1 && (
                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          onClick={() => removeTruckRow(index)}
                          style={{ marginLeft: "10px", marginTop: "15px", width: "35px", height: "35px" }}
                        >
                          -
                        </button>
                      )}
                    </div>
                  ))}
                  {/* ADD MORE BUTTON */}
                  <button
                    type="button"
                    className="button customButton01 active"
                    onClick={addTruckRow}
                  >
                    + Add More
                  </button>

                  {equipmentRows.map((row, index) => (
                    <div className="customFormRow" key={index}>
                      
                      {/* Equipment Name */}
                      <div className="inputField">
                        <input
                          type="text"
                          name="equipment"
                          value={row.equipment}
                          onChange={(e) => handleEquipmentChange(index, e)}
                          placeholder="Enter Equipment Name"
                        />
                      </div>

                      {/* Quantity */}
                      <div className="">
                        <input
                          type="number"
                          name="quantity"
                          value={row.quantity}
                          onChange={(e) => handleEquipmentChange(index, e)}
                          placeholder="Enter Quantity"
                        />
                      </div>

                      {/* Remove Button */}
                      {equipmentRows.length > 1 && (
                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          onClick={() => removeEquipmentRow(index)}
                          style={{ marginLeft: "10px", marginTop: "15px", width: "35px", height: "35px" }}
                        >
                          -
                        </button>
                      )}
                    </div>
                  ))}

                  {/* Add More */}
                  <button
                    type="button"
                    className="button customButton01 active"
                    onClick={addEquipmentRow}
                  >
                    + Add Equipment
                  </button>
                  <div className="customFormRow">
                    {/* <div className="inputField">
                      <input type="file" name="image" onChange={handleImage} multiple accept="image/*" className="form-control" />
                      <span className="validate-error-message">{registerInput.error_list.image}</span>

                    </div> */}
                    <div className="inputField">

                      {isDisplayed &&
                            <AdminAutoComplete
                                apiKey={'AIzaSyCv7m-2LTrrKnu1P38xKNBvvFJXoQGAnGg'}
                                setCoodinationValueAddress={setCoodinationValueAddress}
                            />
                        }

                      <span className="text-danger">{registerInput.error_list.street_address}</span>
                    
                    </div>
                  </div>
                </div>
                )}

               
                <div className="customFormRow">
                  <div className="inputField">
                    <button type="submit" className="button customButton01 active submitButton">Save </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {loader}
      
    </section>

    
  )
}
export default Register;